<template>
  <PageTemplate :class="componentClass" :title="metaTitle">
    <div class="article-custom-view_content">
      <v-row class="flex-column-reverse flex-lg-row">
        <v-col cols="12" lg="8">
          <div v-if="parsedTitle || item.subtitle" class="mb-2">
            <h1 class="secondary--text" v-if="parsedTitle">
              {{ parsedTitle }}
            </h1>
            <div v-if="item.subtitle" class="text-body-2 font-weight-bold mt-2">
              {{ item.subtitle }}
            </div>
          </div>

          <div class="d-flex justify-space-between align-center mb-4">
            <div class="text-body-2">
              <div
                v-if="parsedAuthor"
                class="font-weight-bold grey--text text--darken-2"
              >
                Por: {{ parsedAuthor }}
              </div>
              <div v-if="parsedDate">
                <v-icon size="12">fas fa-calendar-alt</v-icon>
                {{ parsedDate }}
              </div>
            </div>
          </div>

          <div
            v-if="item.text"
            class="ck-content font-weight-medium mb-4"
            v-html="item.text"
          ></div>

          <VideoSection v-if="item.video" class="mb-4" :link="item.video" />
        </v-col>
        <v-col cols="12" lg="4">
          <figure class="mb-2">
            <img v-if="parsedImg" :src="parsedImg" />
            <figcaption
              v-if="item.photo_author"
              class="text-body-2 font-weight-bold grey--text text--darken-2"
            >
              Foto por: {{ item.photo_author }}
            </figcaption>
          </figure>
        </v-col>
      </v-row>

      <GallerySection
        v-if="gallerySection.items.length > 1"
        v-bind="gallerySection"
        no-container
      />
      <ShareButtonWidget :small="xsOnly" />
    </div>
  </PageTemplate>
</template>

<script>
import GallerySection from "../components/sections/GallerySection.vue";
import VideoSection from "../components/sections/VideoSection.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";
import ShareButtonWidget from "../components/widgets/ShareButtonWidget.vue";

/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 *   ?fullWidth: boolean // Se tiver essa propriedade, o template vai ficar 100% do container.
 * }
 */
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return this.$route.meta.mod;
    },
    fullWidth() {
      return this.$route.meta.fullWidth;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest(this.mod).item;
    },
    parsedTitle() {
      return this.item.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      return this.item.img
        ? this.files + this.item.img + "?resize=1&w=600"
        : null;
    },
    parsedDate() {
      return this.item.date
        ? new Date(this.item.date).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : null;
    },
    parsedAuthor() {
      if (typeof this.item.author === "string") {
        return this.item.author;
      } else {
        return this.item.author?.title;
      }
    },
    gallerySection() {
      const gallerySection = {};

      gallerySection.items = this.item.img?.list || [];
      gallerySection.items = gallerySection.items.map(({ path }) => ({
        src: this.files + path,
      }));

      gallerySection.cols = {
        xs: 2,
        sm: 3,
        md: 3,
        lg: 4,
        xl: 4,
      };

      return gallerySection;
    },
    audios() {
      return this.item.audio?.list || [];
    },
    attachments() {
      return this.item.files?.list || [];
    },
    componentClass() {
      return this.fullWidth && "article-custom-view_full";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    updateTitle() {
      return (document.title = this.$rest(this.mod).item.title);
    },
  },
  watch: {
    itemId() {
      this.$rest(this.mod)
        .get({ id: this.itemId })
        .catch(() => this.$router.replace({ path: "/erro404" }));
      this.updateTitle();
    },
    $route() {
      this.updateTitle();
    },
    parsedTitle() {
      this.updateTitle();
    },
  },
  created() {
    this.$rest(this.mod)
      .get({ id: this.itemId })
      .catch(() => this.$router.replace({ path: "/erro404" }))
      .finally(() => (this.loading = false));
    this.updateTitle();
  },
  components: {
    GallerySection,
    VideoSection,
    PageTemplate,
    ShareButtonWidget,
  },
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 40px;
  line-height: 100%;
}
.article-custom-view_content {
  figure {
    max-width: 720px;
    margin: 0 auto;
  }
  img {
    width: 100%;
    border-radius: 12px;
  }
}
</style>
